import React from 'react'

export default function UpgradeArrow(props) {
  return (
    <svg
      width={props.width ? props.width : '117'}
      height={props.height ? props.height : '75'}
      viewBox='0 0 117 75'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_d)'>
        <path
          d='M14.4677 67.8991L14.9623 67.4623L48 34.4288L65.2877 51.7123C67.1802 53.6049 70.1582 53.7504 72.2177 52.1491L72.7123 51.7123L95.25 29.1788L102.038 35.9623C105.201 39.1258 110.513 37.1203 110.969 32.8466L111 32.25L110.991 10.9382L110.944 10.4785L110.812 9.85434L110.686 9.45625L110.508 9.02809L110.234 8.51628L109.882 8.01064L109.462 7.53752C109.276 7.35188 109.08 7.1829 108.875 7.03076L108.291 6.65453L107.7 6.37394L107.146 6.18819L106.529 6.05785L106.219 6.02083L105.75 6H84.75C80.2761 6 77.9385 11.174 80.6381 14.5183L81.0377 14.9623L87.8213 21.75L69 40.5713L51.7123 23.2877C49.8198 21.3952 46.8418 21.2496 44.7823 22.8509L44.2877 23.2877L7.53769 60.0377C5.48744 62.0879 5.48744 65.4121 7.53769 67.4623C9.43023 69.3549 12.4082 69.5004 14.4677 67.8991Z'
          fill={props.fill ? props.fill : '#1D79FB'}
        />
      </g>
      <defs>
        <filter id='filter0_d' x='0' y='0' width='117' height='75' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' />
          <feOffset />
          <feGaussianBlur stdDeviation='3' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow' result='shape' />
        </filter>
      </defs>
    </svg>
  )
}
